import { HTTP } from './helpers/http.js'

export default {
  getSiteSituationTypesList(organizationId, siteId) {
    const url = `/api/v1/organizations/${organizationId}/sites/${siteId}/situation-types/list`
    return HTTP.get(url)
  },

  getOrganizationCatalog(organizationId) {
    const url = `/api/v1/organizations/${organizationId}/situation-types`
    return HTTP.get(url)
  },

  getOrganizationRules(organizationId) {
    const url = `/api/v1/organizations/${organizationId}/settings/situation-types/rules`
    return HTTP.get(url)
  },

  createOrganizationRule(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/settings/situation-types/rules`
    return HTTP.post(url, data)
  },

  updateOrganizationRule(organizationId, ruleId, data) {
    const url = `/api/v1/organizations/${organizationId}/settings/situation-types/rules/${ruleId}`
    return HTTP.patch(url, data)
  },

  getSiteRules(organizationId, siteId) {
    const url = `/api/v1/organizations/${organizationId}/sites/${siteId}/settings/situation-types/rules`
    return HTTP.get(url)
  },

  createSiteRule(organizationId, siteId, data) {
    const url = `/api/v1/organizations/${organizationId}/sites/${siteId}/settings/situation-types/rules`
    return HTTP.post(url, data)
  },

  updateSiteRule(organizationId, siteId, ruleId, data) {
    const url = `/api/v1/organizations/${organizationId}/sites/${siteId}/settings/situation-types/rules/${ruleId}`
    return HTTP.patch(url, data)
  },

  removeOrganizationRule(organizationId, ruleId) {
    const url = `/api/v1/organizations/${organizationId}/settings/situation-types/rules/${ruleId}`
    return HTTP.delete(url)
  },
}
